import { makeStyles } from 'tss-react/mui';

import { linearProgressClasses } from '@mui/material';

export default makeStyles({ name: 'LicenseCreditBar' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4
    },
    info: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px',
        letterSpacing: '-0.24px'
    },
    title: {
        color: '#8E8E8E',
        flex: 1
    },
    amount: {
        color: '#393939'
    },
    progress: {
        background: '#E4E4E4',
        borderRadius: 2,
        [`& .${linearProgressClasses.bar}`]: {
            backgroundColor: '#2D2D2D',
            borderRadius: 2
        }
    }
});
